import {
  Alert,
  getAlertCommentaryKey,
  getAlertCompType,
  getAlertTypeLabel,
} from '@aloft/toolkit-shared';

import { getAlertToastId } from './constants.ts';
import { dismissInactiveAlertToasts, isAlertToastRegistered } from './dismissAllToasts.ts';
import { MakeToast } from './types.ts';

export const applyVisibleAlertToasts = (
  visibleAlerts: ReadonlyArray<Alert>,
  makeToast: MakeToast,
) => {
  dismissInactiveAlertToasts(new Set(visibleAlerts.map(getAlertCommentaryKey)));

  visibleAlerts.forEach((alert) => {
    const alertKey = getAlertCommentaryKey(alert);
    if (isAlertToastRegistered(alertKey)) {
      return;
    }
    makeToast({
      id: getAlertToastId(alertKey),
      alertKey,
      alertType: alert.type,
      alertPropertyID: alert.propertyID,
      alertTargetCellKey: alert.fixingInfo.targetCellKey,
      type: alert.severity,
      title: getAlertTypeLabel(alert.type),
      body: alert.message,
      compType: getAlertCompType(alert),
      comparablesAlerts: true,
      openAlertsOnClick: true,
    });
  });
};
